const ALLOWED_CNPJ = '20276207000109';
const SUPERADMIN_CPF = '03370993406';

export function isAdminBase(user, usuarioBind) {
  return !!(usuarioBind && user && usuarioBind.tipo === 'ADMIN' && user.role === 'ADMIN');
}

export function isAdminAuthorized(user, usuarioBind) {
  return isAdminBase(user, usuarioBind) && usuarioBind.cnpj === ALLOWED_CNPJ;
}

export function isSuperAdmin(user, usuarioBind) {
  if (usuarioBind !== undefined) {
    return isAdminAuthorized(user, usuarioBind) && user?.cpf === SUPERADMIN_CPF;
  }
  return !!(user && user.cpf === SUPERADMIN_CPF);
}

export function isPrivilegedAdmin(user, usuarioBind) {
  // No extra CPFs configured for this project; fallback to superadmin
  return isSuperAdmin(user, usuarioBind);
}

export default { isAdminBase, isAdminAuthorized, isSuperAdmin, isPrivilegedAdmin };
